<!--<div class="loading">
  </div>-->
  
    
       
  <div class="modal-header">
    <h4 class="modal-title"> {{ heading|translate}}</h4>
    <button class="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close" (click)="activeModal.close()">
      
    </button>
  </div>
  <div class="modal-body">
    <!--  <form autocomplete="off"  [formGroup]="newVendor"> -->
         <form autocomplete="off"  [formGroup]="newVendor" class="form-horizontal" role="form" id="AddVendor">
          <div>
              <div class="row">
          <div class="col-md-6" #parent1> 
            <div class="mb-3">
                <label class="text-muted" for="small-square-input"> {{'Vendor'|translate}} Name</label>
                <div class="mb-3" [ngClass]="{ 'has-danger' : (submitted && newVendor.get('name').invalid) }">
                 <!-- <input class="form-control form-control-sm" type="text" id="vendorName" value="37" formControlName="name" required> -->
                 <indic-input [parentEl]="parent1"   tabindex="-1"
                 formControlName="name" required>
                 <show-errors *ngIf="submitted" [control]="newVendor.get('name')" [field]="'Vendor Name'"></show-errors>
                </indic-input>
                 <!-- <small class="text-danger" *ngIf="submitted && newVendor.get('name').hasError('required')">
                    {{'Name'|translate}} required
                   </small> -->
                  
                   </div>
            </div>
           </div>
           <div class="col-md-6" #parent2> 
            <div class="mb-3">
                <label class="text-muted" for="small-square-input">{{'Address'|translate}}</label>
                <div class="mb-3" >
                    <indic-input [parentEl]="parent2"  tabindex="-1"
                    formControlName="address" [inputOptions]="{keyboardEnable:true,inputarea: 'textarea'}" ></indic-input>
                  <!-- <textarea rows="2" class="autogrow form-control form-control-sm transition-height" formControlName="address" ></textarea> -->
               
                  </div>
            </div>
          </div>
         
      
           <div class="col-md-6"> 
            <div class="mb-3">
                <label class="text-muted" for="small-square-input">{{'Phone'|translate}}</label>
                <div class="mb-3" [ngClass]="{ 'has-danger' : (submitted && newVendor.get('phone').invalid) }">
                 <input class="form-control form-control-sm" type="phoneNumber" id="Phonet" value="37" formControlName="phone" >
                      
                   </div>
            </div>
           </div>
           <div class="col-md-6"> 
            <div class="mb-3">
                <label class="text-muted" for="small-square-input">{{'Email'|translate}}</label>
                <div class="mb-3" [ngClass]="{ 'has-danger' : (submitted && newVendor.get('email').invalid) }">
                 <input class="form-control form-control-sm" type="email" id="{{'Email'|translate}}" value="37" formControlName="email"  emailValidator>
                 <show-errors *ngIf="submitted" [control]="newVendor.get('email')" [field]="'Email'"></show-errors>
                   </div>
            </div>
            </div>
           </div>
           <div class="row">
           <div class="col-md-6"> 
              <div class="mb-3">
                  <label class="text-muted" for="small-square-input">{{'Type'|translate}}</label>
              <div class="mb-3" [ngClass]="{ 'has-danger' : (submitted && newVendor.get('type').invalid) }">
           <select class="form-control form-control-sm" formControlName="type"  required>
              
              <option value="VENDOR">{{'Vendor'|translate}}</option>
              <option value="CUSTOMER">{{'Customer'|translate}}</option>
              <option value="BOTH">{{'Both'|translate}}</option>
            </select>
            <!-- <small class="text-danger" *ngIf="submitted && newVendor.get('type').hasError('required')">
                type required
               </small> -->
               <show-errors *ngIf="submitted" [control]="newVendor.get('type')" [field]="'Type'"></show-errors>
               </div>
               
              </div>
          </div>
        </div>
        </div>
          </form>

        
     
  </div>
  <div class="modal-footer">
    <button class="btn btn-secondary btn-sm" type="button" data-bs-dismiss="modal" (click)="activeModal.close()">Close</button>
    <button class="btn btn-primary btn-sm" type="button" (click)="checkSaveEdit()">Submit</button>
    <!-- <button class="btn btn-primary btn-sm" type="button">Reset</button> -->
  </div>



